export const FETCH_TEAMS_START = 'FETCH_TEAMS_START';
export const RECEIVE_TEAMS = 'RECEIVE_TEAMS';
export const FETCH_TEAMS_ERROR = 'FETCH_TEAMS_ERROR';
